// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
// import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import {InputLabel, Select, Stack, Tooltip} from "@mui/material";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from "@mui/material/Typography";

// App Imports


import {
   getDashboardPivot,
} from "../../ContractDataPointValue/ContractDataPointValueClient";


import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {changeWork} from "../../Work/workSlice";
import {getDashboardVersions} from "../../ContractSection/ContractSectionClient";


// main function
export default function DashboardPivot( { closeDashboardPivotDrawer, openSourceWindow } ) {


    const [versions, setVersions] = useState([]);

    // const selectorVersionId = 263;
    const selectorDashboardSectionId = useSelector((state) => state.workSlc.value.selectedDashboardSectionId);
    const selectorVersionId = useSelector((state) => state.workSlc.value.dashboardVersionId);
    const selectorContractId = useSelector((state) => state.workSlc.value.selectedContractId);
    const selectorVersionNumber = useSelector((state) => state.workSlc.value.dashboardVersionId);
    const [rowsIn, setRowsIn] = useState([]);
    const [pivotedRows, setPivotedRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [versionId, setVersionId] = useState( null);
    // const [versionId, setVersionId] = useState(
    //     Number(selectorPropertyDropdownTitleId) || 0
    // );


    const dispatchData = useDispatch();

    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp refresh = true");
    //     fetchDashboardPivot();
    //     dispatchData(changeWork({dashboardPivotState: true, dashboardPivotRefresh: false}));
    // }, [useSelector((state) => state.workSlc.value.dashboardPivotRefresh)===true]);


    const dashboardPivotRefresh = useSelector((state) => state.workSlc.value.dashboardPivotRefresh);


    const fetchVersionsForDropdowns = () =>
        // getAllDataPointVersions()
        getDashboardVersions(selectorDashboardSectionId)

            .then(data => {
                console.log("selectorDashboardSectionId ", selectorDashboardSectionId);
                console.log("Versions List");
                console.log(data);
                setVersions(data);
            })
    useEffect(() => {
        console.log("This is for the versions dropdown...");
        console.log("selectorDashboardSectionId ", selectorDashboardSectionId);
        fetchVersionsForDropdowns();
    }, []);



    useEffect(() => {
        // if (!dashboardPivotRefresh) return;
        fetchDashboardPivot();
        dispatchData(changeWork({ dashboardPivotState: true, dashboardPivotRefresh: false }));
    }, [dashboardPivotRefresh,selectorVersionId, selectorContractId, selectorVersionNumber]);

    const handleRefreshGrid = () => {
        dispatchData(changeWork({dashboardPivotRefresh: true}));
    };


    const handleBackButton = () => {
        dispatchData(changeWork({dashboardPivotState: false}));
    };


    const handleVersionChange = (selectedValue) => {
        dispatchData(changeWork({dashboardVersionId: selectedValue, dashboardPivotRefresh: true}));
    };


    const handleVersionClear = () => {
        setVersionId(null);
        dispatchData(changeWork({dashboardPivotRefresh: true}));
    };


    const handleClose = () => {
        setVersionId(null);
        dispatchData(changeWork({dashboardVersionId: null, dashboardPivotState: false}));
    };


    const fetchDashboardPivot = () => {
        if (selectorVersionId != null ) {
            console.log("fetching dashboard pivot data.");
            console.log("versionId = ", selectorVersionId);
            console.log("versionNumber = ", selectorVersionNumber);
            getDashboardPivot(selectorVersionNumber)
                .then(data=>setRowsIn(data)
                )
                .catch(err => console.error("getDashboardPivot failed", err))
                .finally(() => {console.log("getDashboardPivot completed");
                    console.log("pivot data");
                    console.log(rowsIn)});
        }
    };


    // const fetchDashboardPivot = () => {
    //     if (myVersionId != null || myContractId != null
    //     ) {
    //         console.log("Fetching dashboard data for the following contract:");
    //         console.log(selectorContractId);
    //         getDashboardPivot(selectorVersionId, selectorContractId, selectorVersionNumber)

    //             .then(data => {
    //                 console.log("for Contract #", selectorContractId);
    //                 console.log("CDP data set retrieved");
    //                 console.log(data);
    //                 setRowsIn(data);
    //             })
    //     }
    // };

    // function buildColumns(pivotedRows) {
    //     const colNames = new Set();
    //     for (const row of pivotedRows) {
    //         Object.keys(row).forEach((k) => {
    //             if (k !== "iterationNumber") colNames.add(k);
    //         });
    //     }
    //
    //     return [
    //         { field: "iterationNumber", headerName: "Iteration", width: 120 },
    //         ...Array.from(colNames).sort().map((name) => ({
    //             field: name,
    //             headerName: name,
    //             flex: 1,
    //             minWidth: 160,
    //         })),
    //     ];
    // }
    function buildColumns(pivotedRows) {
        const colNames = new Set();
        for (const row of pivotedRows) {
            Object.keys(row).forEach((k) => {
                if (k !== "id" && k !== "iterationNumber") colNames.add(k);
            });
        }

        return [
            { field: "iterationNumber", headerName: "#", width: 20 },
            // ...Array.from(colNames).sort().map((name) => ({
            ...Array.from(colNames).map((name) => ({
                field: name,
                headerName: name,
                flex: 1,
                align: 'right',
                headerAlign: 'right',
                minWidth: 140,
                headerClassName: "wrap-header",

            })),
        ];
    }


    function pivotForDisplay(rowsIn) {
        const byIter = new Map();

        for (const r of rowsIn) {
            if (!byIter.has(r.iterationNumber)) {
                byIter.set(r.iterationNumber, {
                    id: r.iterationNumber,               // REQUIRED
                    iterationNumber: r.iterationNumber,
                });
            }
            byIter.get(r.iterationNumber)[r.dataPointName] = r.displayValue;
        }

        return Array.from(byIter.values()).sort(
            (a, b) => a.iterationNumber - b.iterationNumber
        );
    }


    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport excelOptions={{ fileName: "dashboard-pivot" }} />
            </GridToolbarContainer>
        );
    }

    // const pivoted = pivotForDisplay(apiRows);
    // const columns = buildColumns(pivoted);

    useEffect(() => {
        const pivoted = pivotForDisplay(rowsIn);
        setPivotedRows(pivoted);
        setColumns(buildColumns(pivoted));
    }, [rowsIn]);

    return (
        <div style={{ height: '100%' , width: '100%' }}>
            <Box style={{ height: 40}}/>
            {/*<Stack direction="row" spacing={12}>*/}
            {/*    <Button onClick={() => handleBackButton()} >BACK</Button>*/}
            {/*</Stack>*/}
            {/*<Button onClick={() => handleRefreshGrid()} >REFRESH</Button>*/}
            <Stack direction="row" spacing={5} alignItems="center">
                <Box>
                    <Tooltip title={"contract id: " + selectorContractId}>
                        <Typography sx={{pl: 2, pt: 2, fontWeight: 'bold' }}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => handleClose()}
                        >View By Version</Typography>
                    </Tooltip>
                </Box>


                {/*<InputLabel htmlFor="versionId">Version</InputLabel>*/}
                {/*<Select*/}
                {/*    labelId="versionId"*/}
                {/*    id="versionId"*/}
                {/*    label="versionId"*/}
                {/*    defaultValue=        {useSelector((state) => state.dataPointXrefSlc.value.versionId)}*/}
                {/*    sx={{ width: 300 }}*/}
                {/* variant={"filled"}>*/}
                {/*    >*/}
                {/*    {versions.map((VersionItem) =>*/}
                {/*        <MenuItem value={VersionItem.id}>{VersionItem.name}</MenuItem>*/}
                {/*    )}*/}
                {/*</Select>*/}


                <FormControl variant="standard" sx={{  minWidth: 600 }}>
                    <InputLabel htmlFor="xyz"  onClick={handleVersionClear}>Version</InputLabel>
                    <Select
                        isClearable={true}
                        id="my_version_id"
                        // onChange={(newVersionId) => {
                        //     setVersionId(newVersionId.target.value);
                        //     // console.log(newVersionId.target.value);
                        //     handleVersionChange(newVersionId.target.value);
                        //     // handleProductTopLevelChange(newProductTopLevelValue.target);
                        // }}
                        onChange={(event) => {
                            const selectedValue = event.target.value;
                            setVersionId(selectedValue);
                            handleVersionChange(selectedValue);
                            // dashboardVersionId(selectedValue)
                        }}
                        // type= "submit"
                        defaultValue=  {selectorVersionId}
                        value = {selectorVersionId}
                    >
                        {versions.map((VersionItem) =>
                            <MenuItem value={VersionItem.dashboardVersionId}>{VersionItem.dashboardVersionId} run on {VersionItem.runTimestamp}</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Stack>
            <br/>
            <br/>
            <DataGridPro
                columnHeaderHeight={80}
                sx={{
                    "& .wrap-header .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: 1.2,
                        overflow: "visible",
                        textOverflow: "clip",
                    },
                }}
                style={{ height: '800px' , width: '1500px' }}
                aria-label={"DashboardPivot"}
                rows={pivotedRows}
                rowThreshold={0}
                onRowClick={(pivotRows)=>openSourceWindow(pivotRows.row)}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns}
                density={"compact"}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'iterationNumber', sort: 'asc' }],
                    },
                }}
                slots={{ toolbar: CustomToolbar }}
            />

        </div>
    );



}




